import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSelectModule } from 'ng-zorro-antd/select';

import { FilterAdvanceDateRangeComponent } from './filter-advance/filter-advance-date-range.component';
import { FilterAdvanceSelectComponent } from './filter-advance/filter-advance-select.component';
import { FilterAdvanceTextComponent } from './filter-advance/filter-advance-text.component';
import { BixiFilterAdvanceComponent } from './filter-advance/fitler-advance.component';

import { BixiFilterKeysComponent } from './filter-keys/filter-keys.component';
import { BixiFilterComponent } from './filter.component';

import { BixiFilterActionsDirective } from './filter.directive';
import { BixiFilterService } from './filter.service';

const COMPONENTS = [
  BixiFilterComponent,
  BixiFilterKeysComponent,
  BixiFilterAdvanceComponent,
  FilterAdvanceTextComponent,
  FilterAdvanceSelectComponent,
  FilterAdvanceDateRangeComponent
];
const SERVICES = [BixiFilterService];

const ZORRO_MODULES = [
  NzCheckboxModule,
  NzPopoverModule,
  NzInputModule,
  NzSelectModule,
  NzDatePickerModule,
  NzDividerModule,
  NzButtonModule,
  NzIconModule,
  NzFormModule
];

const DIRECTIVES = [BixiFilterActionsDirective];

@NgModule({
  imports: [CommonModule, FormsModule, DragDropModule, ...ZORRO_MODULES],
  declarations: [...COMPONENTS, ...DIRECTIVES],
  providers: [SERVICES],
  exports: [...COMPONENTS, ...DIRECTIVES]
})
export class BixiFilterModule { }
